/**
 * ROUND8 - where dog teams appear (docs/milestones/ROUND8-dogs.md, "Where they appear"). The owner,
 * 2026-09-23: "harder missions and maybe higher difficulty should have them"; Classic stays dog-free.
 * How a dog behaves is the sim's (`DOGS`, src/sim/tuningDogs.ts); how many teams a mission carries is the
 * roguelike layer's (src/meta/dogs.ts), and these are its numbers.
 */

export const DOG_TEAMS = {
  /** At Standard, a mission carries one team from this threat rating... */
  oneFrom: 6,
  /** ...and two from this one. */
  twoFrom: 8,
  /**
   * The difficulty slider's Standard detent (0 Milk Run, 1 Standard, 2 Hard, 3 Suicide). Each step above it
   * lowers both thresholds by one threat step; Milk Run raises them by one.
   */
  standard: 1,
  /** Dog Patrols (04 §7): this many teams more than the threat brings... */
  modifierTeams: 1,
  /** ...and the card is only dealt to a mission rated this or higher. */
  modifierFrom: 3,
} as const;
